exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleModal[data-v-ab4f3df0]{z-index:333 !important}.flex-center[data-v-ab4f3df0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.selWidth[data-v-ab4f3df0]{width:320px}", ""]);

// exports
